import { Field, Form } from 'react-final-form'
import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Button } from '../../../elements/controls'
import messages from '../../../elements/forms/messages'
import { requiredEmail } from '../../../elements/forms/validators'
import { TextInput } from '../../../elements/input'

export const ButtonContainer = styled(View)`
  margin-top: ${(props) => props.theme.spacing.medium}px;
`

const FormContainer = styled(View)`
  margin: ${(props) => props.theme.spacing.small}px auto 0;
  align-items: center;
  max-width: 330px;
`

export const AmendEmailForm = ({ email, onPressAmendEmail }) => {
  return (
    <Form onSubmit={onPressAmendEmail} initialValues={{ email }}>
      {({ handleSubmit, submitting, pristine }) => (
        <FormContainer>
          <Field
            name="email"
            validate={requiredEmail}
            render={(fieldProps) => (
              <TextInput
                {...fieldProps}
                style={{ width: 300 }}
                placeholder={messages.email}
                keyboardType="email-address"
                autoCapitalize="none"
                onSubmitEditing={handleSubmit}
                returnKeyType="go"
              />
            )}
          />
          <ButtonContainer>
            <Button
              onPress={handleSubmit}
              intlMessage={submitting ? messages.submitting : messages.resendVerification}
              disabled={submitting || pristine}
              variant="primary"
            />
          </ButtonContainer>
        </FormContainer>
      )}
    </Form>
  )
}

AmendEmailForm.propTypes = {
  email: PropTypes.string.isRequired,
  onPressAmendEmail: PropTypes.func.isRequired,
}
